"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferSection = void 0;
const react_1 = __importDefault(require("react"));
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const helpers_1 = require("@app/component/pages/organization/helpers");
const store_1 = require("@app/store");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const shift_modal_section_1 = require("../components/shift-modal-section");
const shift_context_1 = require("../shift-context");
const isIdDefined = (t) => (0, util_1.isValue)(t.id);
const TransferSection = () => {
    const { targetWsId, setTargetWsId, transferRole, transferMaster, transferSlave, transferGroups, transferType, transferStatus, } = (0, shift_context_1.useShift)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const { countries } = (0, store_1.useRootSelector)((state) => state.organization);
    const isOrg = util_1.miscUtil.isDayswapsProInterface();
    let value;
    let workspaceOptions = [];
    let sectionNameSuffix = '';
    const sameCountryWorkspaces = react_1.default.useMemo(() => {
        const countryCode = workspace?.country;
        const filteredCountries = (isOrg
            ? countries?.filter(util_1.isValue)
            : countries
                ?.filter((country) => country?.code === countryCode)
                .filter(util_1.isValue)) ?? [];
        const allWorkspaces = countries?.flatMap((c) => c?.workspaces).filter(util_1.isValue) ?? [];
        const allWorkspacesMap = new Map(allWorkspaces.filter(isIdDefined).map((ws) => [ws.id, ws]));
        const allAreasWorkspaces = countries
            ?.flatMap((c) => c?.areas?.flatMap((area) => area?.workspaces))
            .filter(util_1.isValue) ?? [];
        // remove existing areas from all workspaces
        allAreasWorkspaces
            .filter(isIdDefined)
            .forEach((ws) => allWorkspacesMap.delete(ws.id));
        const otherWorkspacesMap = allWorkspacesMap;
        const options = (0, helpers_1.getWorkspaceOptions)(filteredCountries);
        const otherWorkspacesOptions = Array.from(otherWorkspacesMap.entries()).map(([id, entry]) => ({
            label: entry.name,
            value: id,
            groupTitle: (0, util_1.t)('OTHER') ?? 'OTHER',
        }));
        return (options
            .filter((workspaceData) => typeof workspaceData.value === 'string' &&
            typeof workspaceData.label === 'string' &&
            workspaceData.value !== workspace?.id)
            .map((workspaceData) => ({
            label: workspaceData.label,
            value: workspaceData.value,
            groupTitle: workspaceData.groupTitle,
        }))
            // @ts-expect-error
            .concat(otherWorkspacesOptions));
    }, [workspace?.country, countries, workspace?.id]);
    if (transferType === 'dsProTransfer' && transferStatus === 'create') {
        workspaceOptions = sameCountryWorkspaces;
        value = workspaceOptions.find((w) => w.value === targetWsId);
        sectionNameSuffix = workspace?.name
            ? `${(0, util_1.t)('EDIT_SHIFT_CREATE_TRANSFER_WS_FROM').toLowerCase()} ${workspace?.name}`
            : '';
    }
    else if (transferType === 'dsProTransfer' &&
        transferStatus === 'accepted' &&
        workspace?.name) {
        value = {
            label: workspace?.name,
            value: workspace?.name,
        };
        workspaceOptions = [value];
        sectionNameSuffix = transferSlave?.workspaceName
            ? `${(0, util_1.t)('EDIT_SHIFT_CREATE_TRANSFER_WS_FROM').toLowerCase()} ${transferSlave.workspaceName}`
            : '';
    }
    else if (transferMaster) {
        value = {
            label: transferMaster.workspaceName,
            value: transferMaster.workspaceName,
        };
        workspaceOptions = [value];
    }
    else if (transferSlave) {
        value = {
            label: transferSlave.workspaceName,
            value: transferSlave.workspaceName,
        };
        workspaceOptions = [value];
    }
    else {
        workspaceOptions = transferGroups;
        value = workspaceOptions.find((w) => w.value === targetWsId);
    }
    return (react_1.default.createElement(shift_modal_section_1.ShiftModalSection, { id: 'transfer', sectionNameSuffix: sectionNameSuffix },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement("div", { style: {
                    width: '100%',
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center',
                } },
                react_1.default.createElement(ui_1.Dropdown, { disabled: Boolean(transferMaster || transferSlave), singleSelect: true, searchable: true, style: ui_1.Dropdown.STYLES.LIGHT, type: ui_1.Dropdown.TYPES.VARIABLE, size: 'full-width', options: workspaceOptions, value: value, onChange: ({ value }) => {
                        if ((0, util_1.isDefined)(value)) {
                            setTargetWsId(value);
                        }
                    }, disableSort: true, placeholder: (0, util_1.t)('SELECT'), label: transferRole === 'master' && transferType !== 'dsProTransfer'
                        ? (0, util_1.t)('EDIT_SHIFT_CREATE_TRANSFER_WS_FROM')
                        : (0, util_1.t)('EDIT_SHIFT_CREATE_TRANSFER_WS_TO') })))));
};
exports.TransferSection = TransferSection;
